export default "__VITE_ASSET__DD3B4UBu__"